module.exports = __webpack_public_path__ + "img/brushes-en-5.bb5d839.jpg";